// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__oDciE","main":"Button_main__je-JO","secondary":"Button_secondary__P0v44"};